import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { IGetState, TCardId } from '../../../../../types/types';
import { fetchHandler } from '../../../../../util/fetchHandler';
import { REST_CHATS } from '../../../../constants';
import { getRestHeadersGet } from '../../../../helpers/getRestHeadersHelper';
import { Util } from '../../../../../util/util';

//TODO done
/***
 * Для миграции доски. Создаем всем чаты
 * @param cardId
 */
export const joinAllForCardRest = (
    cardId: TCardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<void>(
            Util.getApiUrl(`${REST_CHATS}chat/card/${cardId}/joinAll`), getRestHeadersGet()
        );
    };
    return action;
};
